export enum AuthProvider {
    LOCAL = 'local',
    AZURE = 'azure',
    GOOGLE = 'google'
}

export enum LoginScope {
    WEB_APP = 'web_app',
    MOBILE_APP = 'mobile_app',
}
